<monitoring-header componentName="{{ serviceName }}"></monitoring-header>

<div style="margin-top: 25px">
  <div class="pagenation">
    <div style="display: inline" class="user-details" *ngIf="userId">
      User ID: {{ this.userId }}
    </div>
    <div style="display: inline; padding-left: 2%">
      <mat-form-field appearance="outline">
        <mat-label>Selected date</mat-label>
        <input
          matInput
          #ref
          [matDatepicker]="picker"
          [formControl]="date"
          disabled="true"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
    <ng-container matColumnDef="noOfHits">
      <th mat-header-cell *matHeaderCellDef>No Of Hits</th>
      <td mat-cell *matCellDef="let element">{{ element.noOfHits }}</td>
    </ng-container>

    <ng-container matColumnDef="firstRequestOfDay">
      <th mat-header-cell *matHeaderCellDef>
        First Request of Day
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.firstRequestOfDay }}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastRequestOfDay">
      <th mat-header-cell *matHeaderCellDef>
        Last Request of Day
      </th>
      <td mat-cell *matCellDef="let element">{{ element.lastRequestOfDay }}</td>
    </ng-container>

    <ng-container matColumnDef="serviceName">
      <th mat-header-cell *matHeaderCellDef>Service Name</th>
      <td mat-cell *matCellDef="let element">{{ element.serviceName }}</td>
    </ng-container>

    <ng-container matColumnDef="averageResponseTime">
      <th mat-header-cell *matHeaderCellDef>
        Avg Response Time
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.averageResponseTime }}
      </td>
    </ng-container>

    <ng-container matColumnDef="minResponseTime">
      <th mat-header-cell *matHeaderCellDef>
        Min Response Time
      </th>
      <td mat-cell *matCellDef="let element">{{ element.minResponseTime }}</td>
    </ng-container>

    <ng-container matColumnDef="maxResponseTime">
      <th mat-header-cell *matHeaderCellDef>
        Max Response Time
      </th>
      <td mat-cell *matCellDef="let element">{{ element.maxResponseTime }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="userId && onRowclick(row)"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        No Records.
      </td>
    </tr>
  </table>
  <mat-paginator
    class="pagenation mat-elevation-z8"
    #paginator
    [pageSizeOptions]="[5, 10, 15, 20]"
    showFirstLastButtons
  ></mat-paginator>
</div>

<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
</div>
